module.exports = __webpack_public_path__ + "img/planeswalker.e11e0ba4.png";